import React, { useEffect } from 'react';

export default function TermsOfUse() {
  useEffect(() => {
    document.title = 'Privacy Policy :: Productions.com';
  }, []);

  return (
    <section class="filmjob_section homepage terms">
      <div class="container font-dm">
        <div class="row">
          <h1 class="col-sm-12 filmjob_heading first">
            Productions.com Privacy Policy Summary
          </h1>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text first">
            This Website Privacy Policy Summary ("Summary") constitutes the full
            Productions.com Privacy Policy. This Summary and the full Privacy
            Policy apply to those Productions.com websites or mobile
            applications that display or link to this Summary.
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_subheading">Additional Information</div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text list">
            When you request information, subscribe to a mailing list or for a
            service or respond to an online survey, we will ask you to provide
            personal data.
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text list">
            The information we collect from you, your device or from publicly
            available sources, may be combined with information obtained from
            other Productions.com services.
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text list">
            We use cookies and other technologies to keep track of your
            interactions with our sites and services to offer a personalized
            experience.
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_subheading">
            Our Use of Your Information
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text list">
            We use the information we collect to provide the Services you
            request.
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text list">
            We use your information to inform you of other products or services
            offered by Productions.com, and to send you relevant survey
            invitations related to Productions.com's services.
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text list">
            We do not sell, rent, or lease our customer lists to third parties.
            In order to help provide our services, we occasionally provide
            non-sensitive information to other companies that work on our
            behalf.
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_subheading">
            Your Rights and Choices
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text list">
            You can stop the delivery of promotional e-mails from
            Productions.com by following the instructions in the e-mail you
            receive.
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text list">
            To view and edit your personal data, please send an e-mail to
            hello@productions.com.
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text list">
            In your capacity as a data subject, you may have certain rights. For
            more information about these rights and how to exercise them, please
            see the full Productions.com Terms of Use.
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_subheading">Important Information</div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text list">
            We cannot be responsible for the privacy practices of any websites
            or pages not under our control and we do not endorse any third-party
            websites or pages, the services or products described or offered on
            such sites or pages, or any of the content contained on those sites
            or pages.
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_subheading">
            Contacting Productions.com
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text list">
            For more information about our privacy practices write us at
            Hello@productions.com.
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_subheading">
            Productions.com Privacy Policy
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text">
            Productions.com is committed to protecting your privacy and
            developing technology that gives you a powerful and safe online
            experience. This Privacy Policy (the "Policy") applies to
            Productions.com and its Services and governs online data collection
            and usage. By using Productions.com or its Services you consent to
            the data practices described in this Policy. All capitalized words
            not defined herein shall have the meanings ascribed to them in the
            Terms of Use.
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_subheading">
            Collection of your Personal Data
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text">
            Productions.com collects personal data from you, including, but not
            limited to, your e-mail address, name, job title, company name or
            organization name, and telephone number. Additionally, provided you
            consent, Productions.com may collect location data received from a
            GPS-enabled mobile device or other mechanism that you have set up in
            order to show your location to other Users or provide information,
            including target advertising or promotions, to you specific to your
            geographic locality via Productions.com. Many GPS-enabled mobile
            devices allow users to "turn off" location-enabling data being sent
            to Productions.com or any other party. If you do not wish to provide
            us with your location, please disable the location-enabling
            functionality on your device when prompted by the Platform or simply
            update your preferences on the Platform to preclude collection of
            your location data.
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text">
            Productions.com automatically collects certain information about
            your computer or mobile device hardware and software. This
            information can include: your IP address, mobile device type and
            model, browser type, device ID, domain names, access times and
            referring web site addresses. This information is used by
            Productions.com for the operation of Productions.com, to maintain
            quality of Productions.com, and to provide general statistics
            regarding use of Productions.com.
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text">
            Productions.com may also collect information about you, such as
            name, email address, and use of social media websites, from publicly
            available sources. Productions.com may collect this information by
            searching the Internet, including publicly available social media
            profiles, and may add the information collected to your user
            profile.
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text">
            Productions.com may also collect demographic information, such as
            ZIP code, age, gender, preferences, interests, and favorites.
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text">
            Please keep in mind that if you directly disclose personal data or
            sensitive personal data through Productions.com or its Services
            (including, for clarity, the Communication Services), this
            information may be collected and used by others. (Note:
            Productions.com does not read any of your private online
            communications with other Users of Productions.com or its Services.)
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text">
            We will retain your personal data for the period necessary to
            fulfill the purposes outlined in this Policy and other legitimate
            business purposes unless we are otherwise required by law to dispose
            of your personal data. If you close your account, we will retain
            certain data for analytical purposes and recordkeeping purposes, as
            well as to prevent fraud, enforce our Terms of Use, take actions we
            deem necessary to protect the integrity of Productions.com or our
            users, or take other actions otherwise permitted by law. In
            addition, if certain information has already been provided to third
            parties as described in this Privacy Policy, retention of that
            information will be subject to those third parties’ policies.
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_subheading">
            Collection of the Personal data of Others
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text">
            In addition to your personal data, Productions.com also may collect
            the personal data of others. If you so choose, the Productions.com
            may be used to upload and store your contacts (or individual
            entries) as part of the Services, for the purpose of enhancing your
            experience and growing your network by leveraging these contacts in
            various ways, including (i) suggesting potential contacts through
            Productions.com with whom you have not yet connected, (ii) giving
            you the option to choose whether to invite contacts in your address
            book who are not yet users of Productions.com or Services to use
            Productions.com in order to grow your Productions.com network, and
            (iii) any other services or tools which Productions.com may acquire
            or develop in the future to enhance your experience using
            Productions.com and the Services. Information of your contacts may
            include names, e-mail addresses, phone numbers, and other
            identifiers. Your contacts information may be uploaded to the
            platform directly from the devices you use to access Productions.com
            or by explicitly granting Productions.com authorization to access
            your contacts information stored on third party sites or services.
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_subheading">Third-Party Web Sites</div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text">
            You may have the option to enter third party sites or pages through
            Productions.com. Productions.com cannot be assured that such
            third-party sites or pages follow Productions.com’s, or equivalent,
            privacy policies. As such, we have no responsibility or liability
            for the actions or policies of such third-party sites or pages, nor
            do we endorse any product or service that may be mentioned or
            offered in such sites, and are not otherwise responsible for the
            content or privacy practices of such sites.
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_subheading">
            Use of your Personal Data and the Personal Data of Others
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text">
            Productions.com collects and uses your personal data and such other
            personal data of others you may provide us, to operate
            Productions.com and deliver the services you have requested.
            Productions.com also uses your personal data to inform you of other
            products or services available from Productions.com and its
            affiliates. Productions.com may also contact you via surveys to
            conduct research about your opinion of current services or of
            potential new services that may be offered by Productions.com.
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text">
            Productions.com may monitor the websites and pages our customers
            visit within the platform, in order to determine what
            Productions.com services are the most popular among
            Productions.com’s customers or users. This data is used to deliver
            customized content and advertising within the Productions.com
            platform to customers whose behavior indicates that they are
            interested in a particular subject area.
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text">
            Except as set forth in this Policy, we will not use, disclose, or
            transfer your personal data or the personal data of others you have
            provided us unless (1) you expressly authorize us to do so; (2) it
            is necessary to allow our service providers or agents to provide
            services for us, (3) it is necessary in order to provide our
            products or services to you (and contacting you when necessary), (4)
            we are sending you other information that may be useful to you, (5)
            subject to applicable contractual or legal restrictions, it is
            disclosed to entities that perform marketing services on our behalf
            or to other entities with whom we have joint marketing agreements,
            (6) it is necessary to protect the confidentiality or security of
            your records, (7) subject to applicable contractual or legal
            restrictions, it is necessary in connection with a sale of all or
            substantially all of the assets of Productions.com or the merger of
            Productions.com into another entity or any consolidation, share
            exchange, combination, reorganization, or like transaction in which
            Productions.com is not the survivor, (8) it is necessary in
            connection with other business purposes including, without
            limitation, customer care, service quality, business management and
            operation, risk assessment, security, fraud and crime
            prevention/detection, monitoring, research and analysis, marketing,
            customer purchasing preferences and trends and dispute resolution,
            (9) it is necessary to comply with law enforcement, governmental
            mandate, or other legal requirement, if appropriate, for your
            protection or in connection with an investigation or prosecution of
            possible unlawful activity; (10) it is necessary for us to provide
            it to our attorneys, accountants, regulators, auditors or other
            advisors; or (11) it is otherwise necessary for us to disclose it as
            required or permitted by law.
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text">
            We use various web site analytics tools and technologies regarding
            activities on our web sites that require storage of web session
            data. The overall aim of these tools is to aid in making our web
            sites easy to use, to proactively identify and correct error
            conditions and to provide more relevant advertising and content to
            you. These tools and technologies are also used to assist web site
            visitors who report problems in the use of our web sites. Stored web
            session data is used in accordance with this privacy policy.
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_subheading">
            Disclosure of Personal data to Third Parties
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text">
            Productions.com does not sell, rent, or lease its customer lists or
            the identity of individual customers to third parties.
            Productions.com may, from time to time, contact you on behalf of
            external business partners about a particular offering that may be
            of interest to you. In those cases, your unique personal data is not
            transferred to the third party.
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text">
            Productions.com may share personal data with trusted partners to
            help us perform statistical analysis, send you email or postal mail,
            provide customer support, or arrange for deliveries. All such third
            parties are contractually prohibited from using personal data
            provided by Productions.com except to provide these services to
            Productions.com, and they are required to maintain the
            confidentiality of your information with equal or greater
            protections than those provided by Productions.com.
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text">
            Productions.com shall not use or disclose sensitive personal data,
            such as race, religion, or political affiliations to any entity,
            except as required by statute, regulation, or order of a government
            tribunal, without your express consent.
            <br />
            Productions.com will disclose your personal data, without notice,
            only if required to do so by law or in the good faith belief that
            such action is necessary to: (a) conform to the edicts of the law or
            comply with legal process served on Productions.com or the Platform;
            (b) protect and defend the rights or property of Productions.com;
            and, (c) act under exigent circumstances to protect the personal
            safety of users of Productions.com or the public.
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text">
            Additionally, with respect to personal data of third parties
            provided to us by you via the Platform, we do not share such
            information with any other users of the Platform or third parties,
            unless (i) you expressly authorize us to do so, or (ii) we are
            required to do so by operation of law or regulatory requirement.
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_subheading">Use of Cookies</div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text">
            The Productions.com platform uses cookie technology to help you
            personalize your online experience. A "cookie" is a text file that
            is placed on your hard disk by a web page server. Cookies cannot be
            used to run programs or deliver viruses to your computer. Cookies
            are uniquely assigned to you and can only be read by a web server in
            the domain that issued the cookie to you.
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text">
            One of the primary purposes of cookies is to provide a convenience
            feature to save you time. The purpose of a cookie is to alert a web
            server that you have returned to a specific page. For example, if
            you personalize Productions.com pages, or register with
            Productions.com sites or services, a cookie helps Productions.com to
            recall your specific information on subsequent visits. This
            simplifies the process of recording your personal data, such as
            billing addresses, shipping addresses, and so on. When you return to
            the same Platform, the information you previously provided can be
            retrieved, so you can easily use the Productions.com features that
            you customized.
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text">
            You have the ability to accept or decline cookies. Most web browsers
            automatically accept cookies, but you can usually modify your
            browser setting to decline cookies if you prefer. If you choose to
            decline cookies, you may not be able to fully experience the
            interactive features of the Productions.com services or web sites
            you visit.
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_subheading">
            Security of your Personal data
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text">
            Productions.com secures your personal data, and the personal data of
            others, from unauthorized access, use or disclosure. Productions.com
            secures such personal data you provide on computer servers in a
            controlled, secure environment, protected from unauthorized access,
            use or disclosure. When personal data is transmitted to other web
            sites, it is protected through the use of encryption, such as the
            Secure Socket Layer (SSL) protocol. Nevertheless, no security system
            is impenetrable. We cannot guarantee that information that users of
            Productions.com may happen to transmit or otherwise supply will be
            totally secure.
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_subheading">
            Communications with Productions.com
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text">
            We appreciate your questions and comments about the Platform and
            Services and welcome your messages to recipients listed on the
            Platform including messages or emails provided to our customer
            support. We will share your communications with those within our
            organization who are most capable of addressing the issues contained
            in your message. We may archive your message for a certain period of
            time or discard it, but your e-mail address and e-mail will only be
            used in accordance with this Policy.
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_subheading">
            Promotions and Advertisements
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text">
            We may send you e-mails or other communications and third-party
            advertisements with promotional offers if you opt-in to receiving
            such communications or advertisements. If you would no longer like
            to receive special promotion information, advertisements, or other
            messages from us or third-party advertisers, please email at
            Hello@productions.com, follow the "Unsubscribe" instructions on such
            messages, or update your setting and preferences on Productions.com.
            Please allow us a reasonable period of time in order to satisfy your
            request, as some advertising campaigns or promotions may already be
            in process at the time you request to no longer be sent such
            advertisements or promotions.
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_subheading">
            Contests, Sweepstakes and Other Promotions
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text">
            On the Productions.com platform, you may wish to participate in
            contests, sweepstakes and other promotions that we may offer from
            time to time. Through these promotions, you may choose to
            participate in activities such as sharing information found on
            Productions.com or such social media platforms with others and
            sending e-mail invitations. In connection with any contests,
            sweepstakes and other promotions that we may offer from time to time
            via Productions.com or such platforms, we use the information you
            provide to administer the contests, sweepstakes and other
            promotions. Subject to applicable contractual or legal restrictions,
            we also may use the information to communicate with you, or the
            other people you select, about our products and services or our
            partners may use such information to communicate with you about the
            contests, sweepstakes or other promotions or their products and
            services. If you choose to participate in these promotions, and are
            eligible to do so, we may ask you for information such as your name,
            e-mail address, date of birth and telephone number.
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_subheading">
            Social Media Platforms and Web sites
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text">
            By visiting any of our pages that are contained on a social media
            platform or web site, you are representing and warranting to us that
            you have reviewed the applicable privacy policy and terms of use of
            such platform or web site and that you will abide by all such
            provisions contained therein.
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text">
            Productions.com offers social-type features on its platform, please
            be aware that these areas may allow you to publicly post, and share
            with other users, certain messages, content, or other information
            (e.g., profile updates and information, job postings, pictures,
            requests for information from other users, recommendations, etc.).
            Although we may take certain precautions to protect those who use
            these areas of Productions.com, we encourage you to be wary of
            giving out any personal data, or any personal data of others to
            which you may have access, in such forums. The information you post
            can be collected and used by people you don't know. We cannot
            guarantee the privacy and safety of these areas and are therefore
            not responsible for any information you choose to post. Your use of
            these features is fully at your own risk.
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_subheading">
            Special Policy for Job Applicants
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text">
            Any personal data that you provide to us when applying for a career
            position with us will be used solely to consider and act upon your
            application. We may retain your personal data for a period of time,
            but only for as long as necessary for such purposes or as otherwise
            required or permitted by law. We may disclose your personal data to
            our agents for the purpose of evaluating your qualifications for the
            particular position you applied for, for other available positions
            or as otherwise required by law. We may also disclose your personal
            data to third parties hired by us to collect, maintain, and analyze
            candidates for career positions or as otherwise required by law.
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_subheading">
            Using the Productions.com Platform or Services From Outside the
            United States
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text">
            If you are using Productions.com or Services from outside of the
            United States, please be aware that your information, including any
            personal data to which we may be given access, may be transferred
            to, stored, or processed in the United States. Alternatively, if you
            are using Productions.com or its Services from within the United
            States, such information may be transferred to, stored, or processed
            in a jurisdiction outside the United States. The data protection and
            other laws of the United States and other countries may not be as
            comprehensive as those in your country, but we will take strong
            measures to protect your personal data. By using Productions.com,
            you understand that your personal data may be transferred to our
            facilities and to those third parties with whom we share such
            information as specified in this Policy.
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_subheading">
            No Information Collected from Children
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text">
            Productions.com will never ask for or knowingly collect information
            from children. We are strongly committed to preserving online
            privacy for all of our web site visitors, including children. We do
            not knowingly collect information about children or sell products to
            children. Consistent with the Children's Online Privacy Protection
            Act, we will not knowingly collect any information from children
            under the age of 13. Furthermore, we may restrict entries to any
            contests, sweepstakes or promotions to entrants who are at least 18
            years of age.
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_subheading">Changes to this Policy</div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text">
            We may change this Policy at any time and from time to time. The
            most recent version of the Policy is reflected by the version date
            located at the bottom of this Policy. If we make any material
            changes to our Policy, those changes will apply to the personal data
            collected after the effective date listed on the Policy, and we will
            notify you by placing a notice on Productions.com prior to the
            change becoming effective. We encourage all users to periodically
            review this Policy for the latest information on our privacy
            practices.
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_subheading">
            California Privacy Rights and Do Not Track Disclosures
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text">
            Under California Law, California residents have the right to request
            in writing from businesses with whom they have an established
            business relationship, (a) a list of the categories of personal
            data, such as name, e-mail, and mailing address, and the type of
            services provided to the customer, that a business has disclosed to
            third parties (including affiliates that are separate legal
            entities) during the immediately preceding calendar year for the
            third parties’ direct marketing purposes and (b) the name and
            address of all such third parties. To request the above information,
            please email us at: Hello@productions.com with a reference to
            California Disclosure Information.
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text">
            We will respond to such requests to information access within 30
            days following receipt at the e-mail stated above. If we receive
            your request at a different e-mail or mailing address, we will
            respond within a reasonable period of time, but not to exceed 150
            days from the date received. Please note that we are only required
            to respond to each customer once per calendar year.
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text">
            We treat the data of everyone who uses Productions.com in accordance
            with this Policy, whatever their Do-Not-Track setting or use of any
            other mechanism that provides them with the ability to exercise
            choice about the collection of their personal data.
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text">
            We give you choices about turning off tailored advertising, sharing
            your information with third parties, and receiving promotional
            offers. You can exercise your choices by emailing us at
            Hello@productions.com, following the "Unsubscribe" instructions on
            promotional messages, or updating your setting and preferences on
            Productions.com.
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_subheading">Contact Information</div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text">
            Productions.com welcomes your comments regarding this Policy. If you
            believe that Productions.com has not adhered to this Policy, please
            contact Productions.com at Hello@productions.com. We will use
            commercially reasonable efforts to promptly determine and remedy the
            problem.
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12 filmjob_text">
            This Policy was last updated on July 2, 2021.
          </div>
        </div>
      </div>
    </section>
  );
}
